<a class="btn primary-ebtn font-weight-bold py-3 px-6" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ngbDropdownToggle>
    {{ 'SETTING_PAGE.IDMS_SETTINGS.ADD' | transloco }}
</a>
<div class="dropdown-menu p-0 m-0 dropdown-menu-md dropdown-menu-left" ngbDropdown>
    <!-- <app-dropdown-menu4></app-dropdown-menu4> -->
    <ul class="navi navi-hover py-5">
        <li class="navi-item">
            <a class="navi-link cursor-pointer" (click)="maintenanceNotificationAdd()">
                <span class="navi-text">{{ 'SETTING_PAGE.IDMS_SETTINGS.SYSTEM_MAINTENANCE_MESSAGE' | transloco }}</span></a
            >
        </li>
        <li class="navi-item">
            <a class="navi-link cursor-pointer" (click)="generalNotificationAdd()"
                ><span class="navi-text">{{ 'SETTING_PAGE.IDMS_SETTINGS.GENERAL_ANNOUNCEMENT' | transloco }}</span></a
            >
        </li>
    </ul>
</div>
